import { Component, OnInit } from '@angular/core';
import { AccountService } from '../components/account/login/services/account.service';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.css']
})
export class RegisterComponent implements OnInit {

  constructor(private userAccount: AccountService) {
    //this.userAccount.setRecovery();
   }

  ngOnInit() {
  }

}
